import { useState } from 'react';
// @mui
import {
  Box,
  Stack,
  Divider,
  Typography,
  Badge,
} from '@mui/material';
// components
import Scrollbar from '../../components/Scrollbar';
import Label from '../../components/Label';
import {
  DailyDoneTodoDialog,
} from '../todo';
// utils
import { fKrDateKST, fKrTrackingTimeShortKST } from '../../utils/formatTime';

// ----------------------------------------------------------------------

export default function TrackingRecordList({ companyId, lastId, trackingData, reloadData }) {
  const [selectedRow, setSelectedRow] = useState(null);
  const [isOpenDoneTodoDialog, setIsOpenDoneTodoDialog] = useState(false);

  const openDoneTodoDialog = (row) => {
    setSelectedRow(row);
    setIsOpenDoneTodoDialog(true);
  };

  const closeDoneTodoDialog = () => {
    setSelectedRow(null);
    setIsOpenDoneTodoDialog(false);
  };

  return (
    <Scrollbar>
      <Stack
        sx={{ mx: 1 }}
        divider={<Divider orientation="horizontal" flexItem />}
      >
        {trackingData && trackingData.map((row) => (
          <TrackingListItem
            lastId={lastId}
            key={row.id}
            row={row}
            onClick={() => openDoneTodoDialog(row)}
          />
        ))}
      </Stack>
      <DailyDoneTodoDialog
        isOpen={isOpenDoneTodoDialog}
        closeDialog={closeDoneTodoDialog}
        row={selectedRow}
        reloadData={reloadData}
        companyId={companyId}
      />
    </Scrollbar>
  )
}

function TrackingListItem({
  lastId,
  row,
  onClick,
}) {
  const {
    id,
    start_at,
    end_at,
    modified_start_at,
    modified_end_at,
    is_manual = false,
  } = row;

  const isRunning = !end_at;
  const modified = modified_start_at && modified_end_at;
  const startDateTime = modified ? modified_start_at : start_at;
  const endDateTime = modified ? modified_end_at : end_at;
  const duration = new Date(endDateTime) - new Date(startDateTime);
  const hours = Math.floor(duration / (1000 * 60 * 60));
  const minutes = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60));

  return (
    <Stack
      sx={{
        mx: 1, my: 1.25,
        px: 1, py: 1.25,
        ':hover': {
          backgroundColor: 'background.neutral',
          cursor: 'pointer',
        },
        ':active': {
          backgroundColor: 'grey.300',
        },
      }}
      spacing={1}
      onClick={onClick}
    >
      <Stack direction="row" spacing={1}>
        <Badge
          color="error"
          variant="dot"
          invisible={lastId >= id}
        >
        <Typography variant="subtitle2" noWrap sx={{ textOverflow: 'ellipsis', pr: 0.5 }}>
          {fKrDateKST(startDateTime)}
        </Typography>
        </Badge>
        {isRunning && (
          <Label variant="ghost" color="info">
            현재 근무중
          </Label>
        )}
        {is_manual && (
          <Label variant="outlined" color="primary" sx={{ ml: 1 }}>
            수동 등록함
          </Label>
        )}
      </Stack>
      <Stack direction="row" spacing={0.5} alignItems="center">
        {!isRunning && (
        <Typography variant="subtitle2" sx={{ color: "text.secondary" }} noWrap>
          {hours > 0 ? `${hours}시간` : ""} {minutes}분
        </Typography>
        )}
        {!isRunning && (
        <Typography variant="subtitle2" sx={{ color: "text.secondary" }} noWrap>
          •
        </Typography>
        )}
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {fKrTrackingTimeShortKST(startDateTime)} ~ {isRunning ? "퇴근전" : fKrTrackingTimeShortKST(endDateTime)}
        </Typography>
      </Stack>
    </Stack>
  );
}
